// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".publication__card[data-v-557e7b4b]{align-items:center}.publication__card-header[data-v-557e7b4b]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
